import * as React from 'react';
import { Text } from '@fluentui/react-components';
import { VTank } from '../../../services';
import { mapToBadgePropsList } from '../../../common/helper';
import BadgeGroup from '../../../components/badgeGroup';
import { EnumRightBarType } from '../../../common/models';
import TabButton from '../../../components/tabButton';

const TankTopBar: React.FC<{
  tank: VTank | undefined | null,
  rightBarType: EnumRightBarType | null,
  alarmCount?: number,
  notificationCount?: number,
  onChangeRightBarType: (t: EnumRightBarType) => void,
}> = ({
  tank,
  rightBarType,
  alarmCount,
  notificationCount,
  onChangeRightBarType,
}) => (
  <div style={{
    height: '100%',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: '0 10px',
  }} >
    <div style={{
      display: 'flex',
      alignItems: 'flex-end',
    }} >
      {
        tank
          ? <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
            <Text size={500} weight='bold'>{tank?.name}</Text>
            <BadgeGroup badges={mapToBadgePropsList(tank)} extended={true} />
          </div> : null
      }
    </div>
    <div style={{
      position: 'relative',
      display: 'flex',
      alignItems: 'center',
      gap: 20,
    }} >
      <TabButton
        label={EnumRightBarType.Alarms}
        expanded={rightBarType === EnumRightBarType.Alarms}
        onClick={() => onChangeRightBarType(EnumRightBarType.Alarms)}
        count={alarmCount}
        highlighted={true}
      />
      <TabButton
        label={EnumRightBarType.History}
        expanded={rightBarType === EnumRightBarType.History}
        onClick={() => onChangeRightBarType(EnumRightBarType.History)}
        count={notificationCount}
      />
      <TabButton
        label={EnumRightBarType.Settings}
        expanded={rightBarType === EnumRightBarType.Settings}
        onClick={() => onChangeRightBarType(EnumRightBarType.Settings)}
      />
    </div>
  </div>
);

export default TankTopBar;
